(() => {
  if (window.AY500Booted) return;
  window.AY500Booted = true;
  let root, cfg, dialog, floating, applyButton, status, expiry = 0;
  let busy = false, verifying = false, lastCart = null, confirmation = null;
  let returnFocus, priorOverflow, syncQueued = false, verifyTimer, commerceUntil = 0;
  let pendingFallback = false, cartRevision = 0;
  const EXPIRY_KEY = 'ay_500_expiry_v1', DISMISS_KEY = 'ay_500_dismiss_v1';
  const PENDING_KEY = 'ay_500_pending_v1', DURATION = 1200000;
  const notices = new WeakMap();
  const sectionOfferStates = new WeakMap();
  const get = key => { try { return localStorage.getItem(key); } catch { return null; } };
  const set = (key, value) => { try { localStorage.setItem(key, String(value)); } catch {} };
  const pending = () => { try { return sessionStorage.getItem(PENDING_KEY) === cfg.code; } catch { return pendingFallback; } };
  const setPending = value => { pendingFallback = value; try { if (value) sessionStorage.setItem(PENDING_KEY, cfg.code); else sessionStorage.removeItem(PENDING_KEY); } catch {} };
  const t = key => cfg.strings[key];
  const api = file => cfg.root.replace(/\/?$/, '/') + file;
  const codes = cart => (cart?.discount_codes || []).filter(x => x.applicable !== false).map(x => String(x.code).toUpperCase());
  const allocations = cart => [...(cart?.cart_level_discount_applications || []), ...(cart?.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(x => ({...x.discount_application, total_allocated_amount:x.amount})))];
  const applied = cart => !!cart?.item_count && (sectionOfferStates.get(cart) === true || allocations(cart).some(x => String(x.title).toUpperCase() === cfg.code && Number(x.total_allocated_amount) > 0));
  function readSectionOfferState(cart) {
    if (!cart || typeof cart !== 'object') return undefined;
    if (sectionOfferStates.has(cart)) return sectionOfferStates.get(cart);
    for (const html of Object.values(cart.sections || {})) {
      if (typeof html !== 'string' || !html.includes('ay500-cart-card')) continue;
      const page = new DOMParser().parseFromString(html, 'text/html');
      const line = page.querySelector('.ay500-cart-card [data-ay500-code-state]');
      if (line?.dataset.ay500Applied === 'true' || line?.dataset.ay500Applied === 'false') {
        const ok = line.dataset.ay500Applied === 'true';
        sectionOfferStates.set(cart, ok);
        return ok;
      }
    }
    return undefined;
  }
  const confirmedCart = cart => Number.isFinite(cart?.item_count) && Array.isArray(cart.items) && (Array.isArray(cart.cart_level_discount_applications) || readSectionOfferState(cart) !== undefined);
  const otherOffers = cart => ({codes:codes(cart).filter(code => code !== cfg.code).sort(), automatic:allocations(cart).filter(x => String(x.title).toUpperCase() !== cfg.code && x.type !== 'discount_code' && !(x.title === '2点以上で10%OFF' && x.value_type === 'percentage' && Number(x.value) === 10) && Number(x.total_allocated_amount) > 0).map(x => String(x.title)).sort()});
  const hasOther = offers => offers.codes.length > 0 || offers.automatic.length > 0;
  async function request(file, options = {}) {
    const controller = new AbortController(), timeout = setTimeout(() => controller.abort(), 9000);
    try {
      const response = await fetch(api(file), {credentials:'same-origin',cache:'no-store',...options,signal:controller.signal,headers:{Accept:'application/json',...options.headers}});
      const data = await response.json();
      if (!response.ok || data.errors || data.status >= 400) throw new Error('cart request failed');
      return data;
    } finally { clearTimeout(timeout); }
  }
  function tick() {
    if (!root?.isConnected) return;
    const now = Date.now();
    if (!Number.isFinite(expiry) || expiry <= now || expiry > now + DURATION) { expiry = now + DURATION; set(EXPIRY_KEY, expiry); }
    const seconds = Math.max(0, Math.ceil((expiry - now) / 1000));
    const label = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
    document.querySelectorAll('[data-ay500-clock]').forEach(node => { if (node.textContent !== label) node.textContent = label; });
  }
  function sync() {
    if (!root?.isConnected) return;
    const modalOpen = document.querySelector('dialog[open]:not(#ay500-dialog), hdt-cart-drawer[open], hdt-modal[open], hdt-drawer[open], .popup-modal.active');
    const path = location.pathname.replace(new RegExp('^' + cfg.root.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')), '').replace(/^\/+/, '');
    const dismissedAt = Number(get(DISMISS_KEY) || 0);
    floating.hidden = !cfg.floating || dialog.open || !!modalOpen || (dismissedAt > 0 && Date.now() - dismissedAt < 43200000) || !/^(?:products\/|collections(?:\/|$)|$)/i.test(path);
    renderOfferState();
    tick();
  }
  function scheduleSync() {
    if (syncQueued) return;
    syncQueued = true;
    requestAnimationFrame(() => { syncQueued = false; sync(); });
  }
  function notice(node, text, timeout = 3000) {
    if (!node) return;
    clearTimeout(notices.get(node)); node.textContent = text;
    notices.set(node, setTimeout(() => { node.textContent = ''; node.hidden = node.hasAttribute('data-ay500-cart-status'); }, timeout));
  }
  function feedback(key) {
    clearTimeout(notices.get(status));
    if (key === 'success' || key === 'saved') notice(status, t(key), 4000);
    else status.textContent = t(key);
  }
  function cartNotice(key) {
    const node = document.querySelector('[data-ay500-cart-status]');
    const parent = document.querySelector('dialog[open]') || root;
    if (node.parentElement !== parent) parent.appendChild(node);
    node.hidden = false; notice(node, t(key), 5000);
  }
  function renderOfferState() {
    if (!lastCart) return;
    const ok = applied(lastCart);
    document.querySelectorAll('[data-ay500-code-state]').forEach(line => {
      line.dataset.ay500Applied = String(ok);
      line.querySelector('[data-ay500-unused]').hidden = ok;
      line.querySelector('[data-ay500-applied-label]').hidden = !ok;
      if (ok && line.querySelector('[data-ay500-copy-status]').textContent) line.querySelector('[data-ay500-copy-status]').textContent = '';
    });
  }
  function updateState(cart) {
    const previouslyApplied = applied(lastCart);
    readSectionOfferState(cart);
    lastCart = cart;
    const ok = applied(cart);
    applyButton.textContent = t(ok ? 'applied' : 'apply');
    if (ok) {
      setPending(false);
      confirmation = null;
      root.querySelector('.ay500-conflict').hidden = true;
      if (status.textContent !== t('success')) {
        clearTimeout(notices.get(status));
        status.textContent = '';
      }
    }
    if (!ok && previouslyApplied) { clearTimeout(notices.get(status)); status.textContent = ''; }
    renderOfferState();
    return ok;
  }
  async function confirmCart(fallback) {
    try { return await request('cart.js'); }
    catch { if (fallback) return fallback; throw new Error('cart confirmation failed'); }
  }
  function close() { if (dialog?.open) dialog.close(); }
  function unlock() {
    if (priorOverflow !== undefined) { document.body.style.overflow = priorOverflow; priorOverflow = undefined; }
    if (returnFocus?.isConnected) returnFocus.focus({preventScroll:true});
    sync();
  }
  async function open(button, preserveConflict = false) {
    if (dialog.open) return;
    returnFocus = button || document.activeElement;
    if (!preserveConflict) { confirmation = null; root.querySelector('.ay500-conflict').hidden = true; status.textContent = ''; }
    priorOverflow = document.body.style.overflow;
    dialog.showModal(); document.body.style.overflow = 'hidden';
    root.querySelector('#ay500-title').focus({preventScroll:true}); sync();
    if (busy) return;
    const revision = cartRevision;
    try { const cart = await request('cart.js'); if (!busy && revision === cartRevision) { updateState(cart); if (!applied(cart) && pending()) feedback('saved'); } } catch { if (!busy && revision === cartRevision && !applied(lastCart)) feedback('failed'); }
  }
  function legacyCopy(button) {
    const previous = document.activeElement, field = document.createElement('textarea');
    field.value = cfg.code; field.readOnly = true;
    field.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:1px;opacity:0;font-size:16px;pointer-events:none';
    (button.closest('dialog,hdt-cart-drawer,hdt-modal,hdt-drawer') || document.body).appendChild(field);
    let copied = false;
    try { field.focus({preventScroll:true}); field.select(); field.setSelectionRange(0, cfg.code.length); copied = document.execCommand('copy'); } catch {}
    finally { field.remove(); previous?.focus({preventScroll:true}); }
    return copied;
  }
  async function copy(button) {
    const label = button.querySelector('[data-ay500-copy-label]'), error = button.parentElement.querySelector('[data-ay500-copy-status]');
    let copied = false;
    if (navigator.clipboard?.writeText) { try { await navigator.clipboard.writeText(cfg.code); copied = true; } catch {} }
    if (!copied) copied = legacyCopy(button);
    clearTimeout(notices.get(label));
    if (copied) { error.textContent = ''; label.textContent = t('copied'); button.setAttribute('aria-label', t('copied')); notices.set(label, setTimeout(() => { label.textContent = t('copy'); button.removeAttribute('aria-label'); }, 2200)); }
    else { error.textContent = t('copy_failed'); }
  }
  const cartElement = () => document.querySelector('wrapp-hdt-cart-page-form form[section-id],hdt-cart-drawer[section-id]');
  function sections() { return [...new Set([...document.querySelectorAll('wrapp-hdt-cart-page-form form[section-id],hdt-cart-drawer[section-id]')].map(node => node.getAttribute('section-id')).filter(Boolean))].slice(0, 5); }
  async function refreshCart(cart) {
    const component = cartElement(), id = component?.getAttribute('section-id');
    if (!component || !id) return;
    if (!cart.sections?.[id]) { cartNotice('refresh_failed'); location.reload(); return; }
    await new Promise(resolve => {
      const eventName = component.matches('form') ? 'cart:page:render' : 'cart:drawer:render';
      const timeout = setTimeout(() => { document.removeEventListener(eventName, done); cartNotice('refresh_failed'); location.reload(); resolve(); }, 4000);
      function done() { clearTimeout(timeout); document.removeEventListener(eventName, done); resolve(); }
      document.addEventListener(eventName, done, {once:true});
      document.dispatchEvent(new CustomEvent('cart:change', {detail:{baseEvent:'ay500:discount',cart:cart}}));
    });
  }
  function commerceBusy() { return Date.now() < commerceUntil || !!document.querySelector('#CartDrawer [aria-busy="true"]:not(.ay500-apply), hdt-product-form [aria-busy="true"], .ae-rec-form [aria-busy="true"]'); }
  async function apply(replace = false, automatic = false) {
    if (busy) return;
    if (commerceBusy()) { if (!automatic) feedback('busy'); else scheduleVerify(600); return; }
    busy = true; cartRevision++; applyButton.disabled = true; applyButton.textContent = t('applying');
    try {
      const current = await request('cart.js');
      if (applied(current)) { updateState(current); feedback('success'); return; }
      const offers = otherOffers(current), signature = JSON.stringify(offers);
      if (hasOther(offers) && (!replace || signature !== confirmation)) {
        confirmation = signature; setPending(false); root.querySelector('.ay500-conflict').hidden = false; status.textContent = '';
        if (automatic && !dialog.open) await open(null, true);
        return;
      }
      root.querySelector('.ay500-conflict').hidden = true;
      if (!current.item_count) { updateState(current); setPending(true); feedback('saved'); return; }
      const cart = await request('cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:cfg.code,sections:sections(),sections_url:location.pathname})});
      const confirmed = await confirmCart(cart);
      updateState(confirmed);
      await refreshCart(cart);
      if (applied(lastCart)) feedback('success');
      else { setPending(false); feedback('failed'); if (automatic) cartNotice('failed'); }
    } catch {
      try { const cart = await request('cart.js'); if (updateState(cart)) { document.dispatchEvent(new CustomEvent('cart:refresh')); feedback('success'); return; } } catch {}
      setPending(false); feedback('failed'); if (automatic) cartNotice('failed');
    } finally { busy = false; applyButton.disabled = false; applyButton.textContent = t(applied(lastCart) ? 'applied' : 'apply'); }
  }
  async function remove(button) {
    if (busy || commerceBusy()) { cartNotice('busy'); return; }
    busy = true; cartRevision++; button.disabled = true; setPending(false);
    try {
      const current = await request('cart.js'), removeCode = button.dataset.ay500Remove.toUpperCase();
      const remaining = codes(current).filter(code => code !== removeCode);
      const cart = await request('cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:remaining.join(','),sections:sections(),sections_url:location.pathname})});
      await refreshCart(cart); updateState(cart); cartNotice(codes(cart).includes(removeCode) ? 'failed' : 'removed');
    } catch { cartNotice('failed'); }
    finally { busy = false; button.disabled = false; }
  }
  async function verifyCart() {
    if (busy || verifying || !root?.isConnected) return;
    if (commerceBusy()) { scheduleVerify(600); return; }
    verifying = true;
    const revision = cartRevision;
    try { const cart = await request('cart.js'); if (!busy && revision === cartRevision) { updateState(cart); if (cart.item_count && pending()) await apply(false, true); } } catch {}
    finally { verifying = false; }
  }
  function scheduleVerify(delay = 150) { clearTimeout(verifyTimer); verifyTimer = setTimeout(verifyCart, delay); }
  function bindRoot() {
    root = document.getElementById('ay500-root');
    if (!root) return false;
    cfg = JSON.parse(root.querySelector('[data-ay500-config]').textContent); cfg.code = cfg.code.trim().toUpperCase();
    dialog = root.querySelector('dialog'); floating = root.querySelector('.ay500-floating'); applyButton = root.querySelector('[data-ay500-apply]'); status = root.querySelector('.ay500-status');
    dialog.addEventListener('close', unlock);
    dialog.addEventListener('click', event => { if (event.target !== dialog) return; const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close(); });
    expiry = Number(get(EXPIRY_KEY)); sync(); scheduleVerify(); return true;
  }
  function boot() {
    if (!bindRoot()) return;
    document.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (!button || !root?.isConnected) return;
      if (button.matches('[data-ay500-open]')) { event.preventDefault(); open(button); }
      else if (button.matches('[data-ay500-close]')) close();
      else if (button.matches('[data-ay500-dismiss]')) { set(DISMISS_KEY, Date.now()); sync(); }
      else if (button.matches('[data-ay500-copy]')) copy(button);
      else if (button.matches('[data-ay500-apply]')) apply();
      else if (button.matches('[data-ay500-replace]')) apply(true);
      else if (button.matches('[data-ay500-keep]')) { root.querySelector('.ay500-conflict').hidden = true; confirmation = null; setPending(false); }
      else if (button.matches('[data-ay500-remove]')) remove(button);
    });
    document.addEventListener('submit', event => { if (event.target.matches('hdt-product-form form,.ae-rec-form')) commerceUntil = Date.now() + 10000; }, true);
    document.addEventListener('quantity-selector:update', () => { commerceUntil = Date.now() + 10000; });
    document.addEventListener('ae:cart:update:start', () => { cartRevision++; commerceUntil = Date.now() + 10000; });
    ['cart:drawer:render','cart:page:render','cart:add:error'].forEach(name => document.addEventListener(name, () => { commerceUntil = 0; sync(); }));
    document.addEventListener('cart:change', event => {
      cartRevision++;
      clearTimeout(verifyTimer);
      const cart = event.detail?.cart;
      if (confirmedCart(cart)) {
        updateState(cart);
        if (cart.item_count && pending()) scheduleVerify(350);
      } else scheduleVerify(350);
    }, true);
    document.addEventListener('cart:refresh', () => { cartRevision++; scheduleVerify(); });
    const observer = new MutationObserver(scheduleSync);
    observer.observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['open','class']});
    window.addEventListener('storage', event => { if (event.key === EXPIRY_KEY) { expiry = Number(event.newValue); tick(); } if (event.key === DISMISS_KEY) sync(); });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) { sync(); scheduleVerify(); } });
    window.addEventListener('pageshow', event => { if (event.persisted) { sync(); scheduleVerify(); } });
    document.addEventListener('shopify:section:load', event => { if (event.target.querySelector('#ay500-root')) { close(); unlock(); bindRoot(); } else scheduleSync(); });
    setInterval(tick, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
})();
